module.exports = __webpack_public_path__ + "static/media/BC1.f09fe11a.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/BC1.png
// module id = 380
// module chunks = 0